export default (array: any[], otherArray: any[]) =>
  array.reduce((acc: boolean, curr) => acc && otherArray.includes(curr), true);